import { observer } from 'mobx-react-lite'
import React from 'react'
import { MessageFieldNodeContent } from 'widgets/Flow/blocks/MessageField'
import { useSmartCallFlowBuilderContext } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/context'
import { SmartCallActionNode } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/Action/ui/SmartCallActionNode/SmartCallActionNode'
import { type ISmartCallNodeProps } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/SmartCallFlowBuilderUi'
import { SendSMSStore } from '../../store/SendSMSStore'

export const SendSMSNode = observer((props: ISmartCallNodeProps) => {
  const { id } = props
  const { getActionById } = useSmartCallFlowBuilderContext()
  const store = getActionById(id)
  if (!(store instanceof SendSMSStore)) return null

  const { sendSMSBlockStore } = store

  return (
    <SmartCallActionNode
      iconProps={SendSMSStore.iconProps}
      title={SendSMSStore.title}
      placeholder={'Add a message'}
      content={
        <MessageFieldNodeContent
          messageFieldStore={sendSMSBlockStore.smsMessageFieldStore.messageFieldStore}
        />
      }
      {...props}
    />
  )
})
